import React, { useState } from 'react';
import { Doughnut } from 'react-chartjs-2';

const COLORS = [
    '#4e73df', '#1cc88a', '#36b9cc', '#f6c23e', '#e74a3b', '#858796'
];

const PieChart = ({ info }) => {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    if (!info) return null;

    const total = (info.data || []).reduce((a, b) => Number(a) + Number(b), 0);

    const labels = info.labels || [];
    const dataVals = info.data || [];

    const hoveredVal = hoveredIndex !== null ? Number(dataVals[hoveredIndex] || 0) : null;
    const hoveredPct = hoveredVal !== null && total > 0 ? ((hoveredVal / total) * 100).toFixed(1) : null;

    const state = {
        labels,
        datasets: [{
            data: dataVals,
            backgroundColor: COLORS.map((c, i) =>
                hoveredIndex === null || hoveredIndex === i ? c : c + '55'
            ),
            borderColor: '#fff',
            borderWidth: 2,
        }]
    };

    const chartOptions = {
        cutoutPercentage: 65,
        legend: { display: false },
        tooltips: { enabled: false },
        hover: { animationDuration: 150 },
        maintainAspectRatio: true,
        onHover: (event, elements) => {
            const next = elements && elements.length > 0 ? elements[0]._index : null;
            setHoveredIndex(prev => prev === next ? prev : next);
        },
    };

    return (
        <div className="card mb-2">
            <div className="card-body p-3">
                <h6 className="font-weight-bold mb-3" style={{ color: '#434343' }}>
                    <i className="fas fa-chart-pie mr-2"></i>Cantidad por propósito
                </h6>
                <div style={{ position: 'relative', width: '160px', margin: '0 auto 12px' }}>
                    <Doughnut data={state} options={chartOptions} />
                    <div style={{
                        position: 'absolute', top: '50%', left: '50%',
                        transform: 'translate(-50%, -50%)', textAlign: 'center', pointerEvents: 'none',
                        transition: 'all 0.15s ease',
                    }}>
                        {hoveredIndex !== null ? (
                            <>
                                <div style={{ fontSize: '1.2rem', fontWeight: 'bold', lineHeight: 1, color: COLORS[hoveredIndex % COLORS.length] }}>{hoveredVal}</div>
                                <div style={{ fontSize: '0.6rem', color: '#888', maxWidth: 60, lineHeight: 1.2, marginTop: 2 }}>{hoveredPct}%</div>
                            </>
                        ) : (
                            <>
                                <div style={{ fontSize: '1.4rem', fontWeight: 'bold', lineHeight: 1, color: '#27314A' }}>{total}</div>
                                <div style={{ fontSize: '0.65rem', color: '#888' }}>Total</div>
                            </>
                        )}
                    </div>
                </div>

                {/* Leyenda personalizada */}
                <div>
                    {labels.map((label, i) => {
                        const val = Number(dataVals[i] || 0);
                        const pct = total > 0 ? ((val / total) * 100).toFixed(1) : 0;
                        const isHovered = hoveredIndex === i;
                        return (
                            <div
                                key={i}
                                className="d-flex align-items-center justify-content-between mb-1"
                                style={{
                                    padding: '2px 4px',
                                    borderRadius: 4,
                                    background: isHovered ? COLORS[i % COLORS.length] + '18' : 'transparent',
                                    transition: 'background 0.15s',
                                }}
                            >
                                <div className="d-flex align-items-center">
                                    <div style={{
                                        width: 10, height: 10, borderRadius: 2,
                                        backgroundColor: COLORS[i % COLORS.length], marginRight: 6, flexShrink: 0
                                    }} />
                                    <small style={{ color: isHovered ? '#333' : '#555', fontWeight: isHovered ? 600 : 400, fontSize: '11px' }}>{label}</small>
                                </div>
                                <small style={{ color: isHovered ? COLORS[i % COLORS.length] : '#999', fontWeight: isHovered ? 600 : 400, fontSize: '11px' }}>{val} ({pct}%)</small>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default PieChart;
